import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_2 = [
  _hoisted_1
]

import { ref, watch, nextTick, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SwitcherComponent',
  props: {
  value: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:value'],
  setup(__props, { emit }) {

const props = __props



const switcherValue = ref<boolean>(false);

watch(
  () => props.value,
  (newValue) => {
    switcherValue.value = newValue;
  }
);



const select = () => {
  switcherValue.value = !switcherValue.value;
  nextTick(() => {
    setTimeout(() => {
      emit('update:value', switcherValue.value);
    }, 100);
  });
};

onMounted(() => {
  switcherValue.value = props.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["switcher", {'active': switcherValue.value}]),
    onClick: select
  }, _hoisted_2, 2))
}
}

})